import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  id: '',
  showModal: false,
  categoryModal: false,
  userDetailsModal: false,
  userShowDetailsModal: false,
  eventDetailsModal: false,
  roomDetailsModal: false,
  bookingDetailsModal: false,
  taskDetailsModal: false,
  eventModal: false,
  assignMemberModal: false,
  forumDetailsModal: false,
  newsModal: false,
  planModal: false,
  subscriptionModal: false,
  memberPlanModal: false,
  memberSubscriptionModal: false,
  webpageModal: false,
  formDetails: {},
  eventDetail: {},
  memberAssignedTrainerDetails:{},
  files: [],
  selectedPage: 1
};

export const sharedSlice = createSlice({
  name: "sharedSlice",
  initialState: initialState,
  reducers: {
    setId: (state, { payload }) => {
      state.id = payload
    },
    setModalStatus: (state, { payload }) => {
      state.showModal = payload
    },
    setFormDetails: (state, { payload }) => {
      state.formDetails = payload
    },
    setEventDetail: (state, { payload }) => {
      state.eventDetail = payload
    },
    setCategoryModalStatus: (state, { payload }) => {
      state.categoryModal = payload
    },
    setUserModalStatus: (state, { payload }) => {
      state.userDetailsModal = payload
    },
    setUserShowModalStatus: (state, { payload }) => {
      state.userShowDetailsModal = payload
    },
    setEventModalStatus: (state, { payload }) => {
      state.eventDetailsModal = payload;
    },
    setBookingModalStatus: (state, { payload }) => {
      state.bookingDetailsModal = payload;
    },
    setRoomModalStatus: (state, { payload }) => {
      state.roomDetailsModal = payload;
    },
    setTaskModalStatus: (state, { payload }) => {
      state.taskDetailsModal = payload;
    },
    setEventDetailModalStatus: (state, { payload }) => {
      state.eventModal = payload;
    },
    setForumModalStatus: (state, { payload }) => {
      state.forumDetailsModal = payload;
    },
    setNewsModalStatus: (state, { payload }) => {
      state.newsModal = payload;
    },
    setPlanModalStatus: (state, { payload }) => {
      state.planModal = payload;
    },
    setSubscriptionModalStatus: (state, { payload }) => {
      state.subscriptionModal = payload;
    },
    setMemberPlanModalStatus: (state, { payload }) => {
      state.memberPlanModal = payload;
    },
    setMemberSubscriptionModalStatus: (state, { payload }) => {
      state.memberSubscriptionModal = payload;
    },
    setWebpageModalStatus: (state, { payload }) => {
      state.webpageModal = payload;
    },
    setFiles: (state, { payload }) => {
      state.files = payload.data
    },
    setPartnerProfileImages: (state, { payload }) => {
      state.formDetails.profilePicture = payload.data[0]?.url
    },
    setSelectedPage: (state, { payload }) => {
      state.selectedPage = payload
    },
    setAssignMembersModalStaus: (state, { payload }) => {
      state.assignMemberModal = payload
    },
    setMemberAssignedTrainerDetails:(state, { payload }) => {
      state.memberAssignedTrainerDetails = payload
    },

  },
});

export const {
  setId,
  setModalStatus,
  setFormDetails,
  setEventDetail,
  setCategoryModalStatus,
  setUserModalStatus,
  setEventModalStatus,
  setRoomModalStatus,
  setBookingModalStatus,
  setEventDetailModalStatus,
  setFiles,
  setPartnerProfileImages,
  setUserShowModalStatus,
  setTaskModalStatus,
  setForumModalStatus,
  setNewsModalStatus,
  setSubscriptionModalStatus,
  setPlanModalStatus,
  setMemberPlanModalStatus,
  setMemberSubscriptionModalStatus,
  setWebpageModalStatus,
  setSelectedPage,
  setAssignMembersModalStaus,
  setMemberAssignedTrainerDetails
} = sharedSlice.actions;